import { render, staticRenderFns } from "./ListSubjects.vue?vue&type=template&id=39def19e&"
import script from "./ListSubjects.vue?vue&type=script&lang=js&"
export * from "./ListSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports